/**
 * CSV download utilities.
 *
 * Uses a data URI instead of URL.createObjectURL so no blob URL is created
 * and nothing appears in the browser network panel on download.
 */

/** Trigger a browser CSV download. No blob URL, no network entry. */
export function downloadCsvFile(csv: string, filename: string): void {
  const a = document.createElement('a');
  a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  a.click();
}

/** Slugify a string for safe use in a filename: lowercase, non-alphanumeric → underscore. */
export function toFileSlug(s: string): string {
  return (s || 'export')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

/** Today's date as YYYY-MM-DD for use in filenames. */
export function todayStr(): string {
  return new Date().toISOString().slice(0, 10);
}
